
























import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { ExistingDocumentEditor } from "./editors";
import {
  DocumentEditViewMixin,
} from "./mixins";

@Component({
  components: {
    FixedLoading,
    ExistingDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class NewCopiedDocumentEditView extends Mixins(DocumentEditViewMixin) {
  @Prop()
  copiedDocumentId: number;

  @Prop()
  chainedFormatIds: number[];

  $refs!: {
    processor: RequestedDocumentProcessor;
  };
}
